import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { first, firstValueFrom, timeout } from 'rxjs';
import { managedServicesForbidden } from 'src/app/core/constants/routes';
import { FeaturesFlagsV2Service } from 'src/app/core/services/features-flags-v2.service';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { devLog } from 'src/app/core/utils/generic-utils';

const pulseSubmodule = 'Pulse';
const featureFlagsTimeoutMs = 10_000;

@Injectable({
  providedIn: 'root',
})
export class MspSubmoduleGuard {
  constructor(
    private userDataService: UserDataService,
    private permissionsService: PermissionsService,
    private featuresFlagsV2Service: FeaturesFlagsV2Service,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    try {
      await this.userDataService.getUserAndCompany();
      const submodule: string = route.data['submodule'];

      if (submodule === 'Pulse' || submodule === 'Ticket Analysis') {
        this.featuresFlagsV2Service.getFeaturesFlags();

        const flags = await firstValueFrom(
          this.featuresFlagsV2Service.featuresFlags$.pipe(
            first((flags) => !!flags?.length),
            timeout(featureFlagsTimeoutMs),
          ),
        );
        if (submodule === 'Pulse') {
          const isPulseEnabled = flags.some((flag) => flag.feature === 'pulse' && flag.isActive);
          if (!isPulseEnabled) {
            this.router.navigate([managedServicesForbidden], { queryParams: { submodule } });
            return false;
          }
        }
        if (submodule === 'Ticket Analysis') {
          const isEnabled = flags.some((flag) => flag.feature === 'ticket-analysis' && flag.isActive);
          if (!isEnabled) {
            this.router.navigate([managedServicesForbidden], { queryParams: { submodule } });
            return false;
          }
        }
      }
      if (submodule && this.permissionsService.hasPermission('managed-services', submodule, 'view')) {
        return true;
      }

      this.router.navigate([managedServicesForbidden], { queryParams: { submodule } });
    } catch (err) {
      devLog(err);
    }

    return false;
  }
}
